import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
export const PAYMENT_ORDER_AUX_HTTP_CONFIG = new InjectionToken(
  'payment-order-aux-service Data Service :: HTTP Config',
);
const examples = [
  {
    urlPattern: '/payment-order-aux-integration-service/v2/payment',
    method: 'POST',
    responses: [
      {
        status: 200,
        body: {
          originatorAccount: {
            arrangementId: '7341696714117907699630',
            externalArrangementId: '7341696714117907600630',
            identification: {
              identification: '8a48e08c60daa5940160dac699050088',
              schemeName: 'ID',
            },
          },
          paymentType: 'IN',
          requestedExecutionDate: '2016-05-16',
          totalAmount: {
            amount: 10.29,
            currencyCode: 'USD',
          },
          transferTransactionInformation: {
            counterpartyAccount: {
              arrangementId: '7341696714117907699630',
              externalArrangementId: '7341696714117907600630',
              identification: {
                identification: '8a48e08c60daa5940160dac699050088',
                schemeName: 'ID',
              },
            },
            instructedAmount: {
              amount: 10.29,
              currencyCode: 'USD',
            },
            counterpartyBank: {
              bankBranchCode: 'bankBranchCode1',
              name: 'Test Bank',
              bic: 'BICExample1',
            },
          },
          transactionInfo: {
            commisionCalculation: 'N',
            taxCalculation: 'Y',
            taxData1: 0,
            taxData2: 0,
            totalAmount: 10,
            transCurAmt: 20,
            commisionAmt: 10,
            exchangeRate: 57.45,
            operationReferenceId: 'bc54531b-222b-4585-b392-f8e020868dc8',
          },
          paymentDescription: 'Optional payment description',
          contactInfo: {
            contactId: '14b0b245-c7a9-427e-8e77-26c2f98dfa3d',
            bankCode: 'ABHRDOS2XXX',
          },
          creditCardPayment: {
            cardOwner: 'SAME_USER',
          },
        },
      },
    ],
  },
];
export const PaymentOrderAuxHttpMocksProvider = createMocks(examples, PAYMENT_ORDER_AUX_HTTP_CONFIG);
